import React from 'react';
import { formatCurrency } from '../../lib/format';

export const MoneyModeCtx = React.createContext('full');
export const useMoneyMode = () => React.useContext(MoneyModeCtx);

const fmtMoney = (n, mode) => formatCurrency(n, 'INR', { mode });

export const MoneyCell = ({ value }) => {
  const mode = useMoneyMode();
  return <span className="font-mono tabular-nums">{fmtMoney(value, mode)}</span>;
};

export const PnLMoney = ({ value }) => {
  const mode = useMoneyMode();
  if (value === 0 || value === null || value === undefined) {
    return <span className="font-mono tabular-nums">{fmtMoney(value, mode)}</span>;
  }
  const cls = value > 0 ? 'pnl-positive' : 'pnl-negative';
  return (
    <span className={`font-mono tabular-nums ${cls}`}>
      {value > 0 ? '+' : ''}{fmtMoney(value, mode)}
    </span>
  );
};
